import React, { useState, useEffect } from 'react'
import { LiaTimesSolid } from "react-icons/lia";
import { FaTrash } from "react-icons/fa";
import { Link, useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify';
import BeHead from '../../Components/Head/BeHead';
import { API } from '../../Services/axios';
import { URLS } from '../../Services/Urls';
import ContentManager from './ContentManager'; 

const BeSelectProjet = () => {
  const { id } = useParams();
  const [isEditMode, setIsEditMode] = useState(!!id);
  const [currentStep, setCurrentStep] = useState(1); // 1: Projet, 2: Créer étape, 3: Sections, 4: Contents
  const [selectedSectionForContent, setSelectedSectionForContent] = useState(null);
  const [selectedStepForContent, setSelectedStepForContent] = useState(null);
  const [projectName, setProjectName] = useState('');
  const [projectDescription, setProjectDescription] = useState('');
  const [projectImage, setProjectImage] = useState('');
  const [imagePreview, setImagePreview] = useState(null);
  
  // Champs pour la création d'étape
  const [stepOrder, setStepOrder] = useState('');
  const [stepTitle, setStepTitle] = useState('');
  const [stepDescription, setStepDescription] = useState('');
  const [oldCreatedSteps, setOldCreatedSteps] = useState([]); // Pour stocker les étapes avant modification
  
  // Champs pour la création de section
  const [sectionOrder, setSectionOrder] = useState('');
  const [sectionTitle, setSectionTitle] = useState('');
  const [selectedStepForSection, setSelectedStepForSection] = useState(null);
  const [editingStep, setEditingStep] = useState(null); // Pour gérer l'édition d'une étape
  const [editingSection, setEditingSection] = useState(null); // Pour gérer l'édition d'une section
  

  

  
  // Données stockées avec contenu dynamique
  const [createdSteps, setCreatedSteps] = useState([]);
  const [contentDetails, setContentDetails] = useState({}); // cache détaillé par content id
  const [editingContent, setEditingContent] = useState(null);
  
  const navigate = useNavigate();

  const UserId = window.localStorage.getItem('userId');

  useEffect(() => {
    if (isEditMode) {
      // On est en mode édition, on charge les données du projet
      API.get(URLS.BE.PROJECT.details(id))
        .then(resp => {
          const projectData = resp.data;
          setProjectName(projectData.nom);
          setProjectDescription(projectData.description);
          // Pour l'image, on affiche l'URL existante
          setImagePreview(projectData.image);
          // On charge les étapes, sections et contenus existants
          // Normaliser la structure : certaines API renvoient `section.contents` au lieu de `section.content`
          const normalizedSteps = (projectData.steps || []).map(step => ({
            ...step,
            sections: (step.sections || []).map(section => ({
              ...section,
              content: section.content || section.contents || []
            }))
          }));
          setCreatedSteps(normalizedSteps);
          
          console.log('Données du projet chargées:', projectData);
          window.localStorage.setItem('beProjetId', id)
        })
        .catch(error => {
          // toast.error(error?.response?.data?.detail || "Erreur lors du chargement du projet");
          console.log('Erreur chargement projet:', error?.response?.data?.detail || error.message);
        });
    }
  }, [id, isEditMode]);

  useEffect(() => {
    // Si on est en mode édition, on charge les étapes existantes
    if (isEditMode) {
      API.get(URLS.BE.STEPS.getStepsByProject(id))
        .then(resp => {
          const stepsData = resp.data;
          // Normaliser les sections dans les steps retournés
          const normalized = (stepsData || []).map(step => ({
            ...step,
            sections: (step.sections || []).map(section => ({
              ...section,
              content: section.content || section.contents || []
            }))
          }));
          setOldCreatedSteps(normalized);
        })
        .catch(error => {
          // toast.error(error?.response?.data?.detail || "Erreur lors du chargement des étapes");
          console.log(error?.response?.data?.detail || "Erreur lors du chargement des étapes");
        });
    }
  }, [isEditMode]);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProjectImage(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSaveOrUpdateProject = () => {
    if (!projectName.trim()) {
      toast.error('Veuillez renseigner le nom du projet');
      return;
    }
    if (!projectDescription.trim()) {
      toast.error('Veuillez renseigner la description du projet');
      return;
    }
  
    const formData = new FormData();
    formData.append('nom', projectName);
    formData.append('description', projectDescription);
    if (!isEditMode) {
      formData.append('created_by', UserId);
    }
    // Si une nouvelle image a été sélectionnée, on l'ajoute.
    // `projectImage` est un objet File si changé, sinon une string (URL) ou vide.
    if (projectImage instanceof File) {
      formData.append('image', projectImage);
    }
  
    const apiCall = isEditMode 
      ? API.patch(URLS.BE.PROJECT.update(id), formData) // Utiliser PATCH pour ne mettre à jour que les champs envoyés
      : API.post(URLS.BE.PROJECT.create, formData);
  
    const successMessage = isEditMode 
      ? "Projet mis à jour avec succès !" 
      : "Projet créé ! Vous pouvez maintenant ajouter des étapes.";
  
    apiCall
      .then((resp) => {
        if (!isEditMode) {
          // En mode création, on stocke le nouvel ID et on passe à l'étape suivante
          window.localStorage.setItem('beProjetId', resp.data.id);
          setIsEditMode(true); // On passe en mode édition pour les étapes suivantes
        }
        toast.success(successMessage);
        setCurrentStep(2);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.detail || `Erreur lors de la ${isEditMode ? 'mise à jour' : 'création'} du projet`);
      });
  };

  const handleSaveStep = () => {
    if (!stepTitle || !stepDescription) {
      toast.error('Veuillez remplir tous les champs de l\'étape');
      return;
    }

    const lengthOfSteps = createdSteps.length;

    const beProjectId = window.localStorage.getItem('beProjetId');
    const stepData = {
      // order: parseInt(stepOrder),
      order: createdSteps.length + 1,
      title: stepTitle,
      description: stepDescription,
      projet: beProjectId,
    };

    if (editingStep) {
      // --- Mise à jour ---
      API.patch(URLS.BE.STEPS.update(editingStep.id), stepData) // Assurez-vous que cet endpoint existe
        .then((resp) => {
          setCreatedSteps(prev => prev.map(s => s.id === editingStep.id ? { ...s, ...resp.data } : s));
          toast.success("Étape mise à jour avec succès !");
          handleCancelEditStep();
        })
        .catch(error => {
          toast.error(error?.response?.data?.detail || "Erreur lors de la mise à jour de l'étape.");
          console.error('erreur MAJ step:', error.response);
        });
    } else {
      // --- Création ---
      API.post(URLS.BE.STEPS.create, stepData)
      .then((resp) => {
        setCreatedSteps(prev => [...prev, { ...resp.data, sections: [] }]);
        toast.success('Étape créée avec succès !');
        handleCancelEditStep(); // Réinitialise le formulaire
      })
      .catch((error) => {
        toast.error(error?.response?.data?.detail || 'Erreur lors de la création de l\'étape');
        console.error('erreur step:', error.response)
      });
    }
  };

  const handleEditStep = (stepToEdit) => {
    setEditingStep(stepToEdit);
    setStepOrder(stepToEdit.order);
    setStepTitle(stepToEdit.title);
    setStepDescription(stepToEdit.description);
    // Fait défiler vers le haut pour voir le formulaire d'édition
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleEditSection = (sectionToEdit) => {
    setEditingSection(sectionToEdit);
    setSectionOrder(sectionToEdit.order);
    setSectionTitle(sectionToEdit.title);
    // Fait défiler vers le haut pour voir le formulaire d'édition
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleCancelEditStep = () => {
    setEditingStep(null);
    setStepOrder('');
    setStepTitle('');
    setStepDescription('');
  };

  const handleCancelEditSection = () => {
    setEditingSection(null);
    setSectionOrder('');
    setSectionTitle('');
  };

  const handleDeleteStep = (stepId) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cette étape ? Ses sections et contenus seront aussi supprimés.")) {
      API.delete(URLS.BE.STEPS.deleteStep(stepId))
        .then(() => {
          toast.success("Étape supprimée avec succès !");
          setCreatedSteps(prev => prev.filter(s => s.id !== stepId));
          if (selectedStepForSection?.id === stepId) {
            setSelectedStepForSection(null);
          }
        })
        .catch(error => {
          toast.error(error?.response?.data?.detail || "Erreur lors de la suppression de l'étape.");
        });
    }
  };

  const handleDeleteSection = (sectionId) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cette section ? Ses contenus seront aussi supprimés.")) {
      API.delete(URLS.BE.SECTIONS.delete(sectionId))
        .then(() => {
          toast.success("Section supprimée avec succès !");
          // Mettre à jour l'état en supprimant la section de la bonne étape
          // setCreatedSteps(prevSteps => prevSteps.map(step => ({
          //   ...step,
          //   sections: step.sections.filter(section => section.id !== sectionId)
          // })));

          // // Si la section supprimée était celle affichée, on nettoie la sélection
          // if (selectedSectionForContent?.id === sectionId) setSelectedSectionForContent(null);

          setCreatedSteps(prev => prev.filter(s => s.id !== sectionId));
          if (selectedStepForSection?.id === sectionId) {
            setSelectedStepForSection(null);
          }
        })
        .catch(error => {
          toast.error(error?.response?.data?.detail || "Erreur lors de la suppression de la section.");
        });
    }
  }

  const handleNextToSections = () => {
    if (createdSteps.length === 0) {
      toast.error('Veuillez créer au moins une étape');
      return;
    }

    setCurrentStep(3);
    toast.success('Étape 2 terminée ! Vous pouvez maintenant créer des sections.');
  };

  const handleSelectStepForSection = (step) => {
    setSelectedStepForSection(step);
    toast.success(`Étape sélectionnée : ${step.title}`);
  };

  const handleCreateSection = () => {
    if (!selectedStepForSection) {
      toast.error('Veuillez sélectionner une étape');
      return;
    }

    if (!sectionTitle.trim()) {
      toast.error('Veuillez remplir tous les champs de la section');
      return;
    }
    
    const beStepId = window.localStorage.getItem('beStepId');
    const sectionData = {
      // order: parseInt(sectionOrder),
      // order: createdSections.length + 1,
      order: selectedStepForSection.sections.length + 1,
      title: sectionTitle,
      step: selectedStepForSection.id,
      // stepTitle: selectedStepForSection.title
    };

    if (editingSection) {
      // --- Mise à jour ---
      API.patch(URLS.BE.SECTIONS.update(editingSection.id), sectionData) // Assurez-vous que cet endpoint existe
        .then((resp) => {
          // Mettre à jour la section dans l'état global `createdSteps`
          const updatedSteps = createdSteps.map(step => step.id === selectedStepForSection.id ? {
            ...step, sections: step.sections.map(s => s.id === editingSection.id ? resp.data : s)
          } : step);
          setCreatedSteps(updatedSteps);
          toast.success("Section mise à jour avec succès !");
          handleCancelEditSection();
        })
        .catch((error) => {
          toast.error("Erreur lors de la mise à jour de la section !");
        })
    } else {
      // --- Création ---
      API.post(URLS.BE.SECTIONS.create, sectionData)
      .then((resp) => {
        // Mettre à jour les étapes avec la nouvelle section
        toast.success("Section créée avec succès !");
        setCreatedSteps(prev => {
          const updatedSteps = prev.map(step => {
            if (step.id === selectedStepForSection.id) {
              return {
                ...step,
                sections: [...step.sections, { ...resp.data, content: [] }]
              };
            }
            return step;
          });
          
          // Mettre à jour selectedStepForSection avec la nouvelle section
          const updatedSelectedStep = updatedSteps.find(step => step.id === selectedStepForSection.id);
          setSelectedStepForSection(updatedSelectedStep);
          
          setSectionTitle('');
          setSectionOrder('');
          return updatedSteps;
       });
      })
      .catch((error) => {
        toast.error("Erreur lors de la mise à jour de la section !");
      })
    // API.post(URLS.BE.SECTIONS.create, sectionData)
    // .then((resp) => {
    //   // Mettre à jour les étapes avec la nouvelle section
    // setCreatedSteps(prev => {
    //   const updatedSteps = prev.map(step => {
    //     if (step.id === selectedStepForSection.id) {
    //       return {
    //         ...step,
    //         sections: [...step.sections, { ...resp.data, content: [] }]
    //       };
    //     }
    //     return step;
    //   });
      
    //   // Mettre à jour selectedStepForSection avec la nouvelle section
    //   const updatedSelectedStep = updatedSteps.find(step => step.id === selectedStepForSection.id);
    //   setSelectedStepForSection(updatedSelectedStep);
      
    //   return updatedSteps;
    // });

    // console.log('Nouvelle section créée:', resp.data);
    // toast.success('Section créée avec succès !');
    
    // // Réinitialiser les champs
    // setSectionOrder('');
    // setSectionTitle('');
    //   // setSelectedStepForSection(null);
    // })
    // .catch((error) => {
    //   toast.error(error?.response?.data?.detail || 'Erreur lors de la création de la section');
    //   console.log('erreur section:', error.response)
    // });
  };
}

  const handleContentAdd = (sectionId, newContent) => {
    setCreatedSteps(prev => prev.map(step => {
      return {
        ...step,
        sections: step.sections.map(section => {
          if (section.id === sectionId) {
            return {
              ...section,
              content: [...(section.content || []), newContent]
            };
          }
          return section;
        })
      };
    }));

    // Mettre à jour la section sélectionnée si elle correspond
    if (selectedSectionForContent && selectedSectionForContent.id === sectionId) {
      setSelectedSectionForContent(prev => ({
        ...prev,
        content: [...(prev.content || []), newContent]
      }));
    }
  };

  const handleContentRemove = async (sectionId, contentToRemove) => {
    if (!window.confirm(`Êtes-vous sûr de vouloir supprimer le contenu "${contentToRemove.name || contentToRemove.label}" ?`)) {
      return;
    }

    try {
      // L'API backend devrait être configurée pour supprimer en cascade
      // les entités liées (Product, Input, OtherChoice, Text)
      // lorsque le Content principal est supprimé.
      await API.delete(URLS.BE.CONTENTS.deleteContent(contentToRemove.id));

      // Mettre à jour l'état local si la suppression API a réussi
      setCreatedSteps(prev => prev.map(step => ({
        ...step,
        sections: step.sections.map(section => {
          if (section.id === sectionId) {
            return {
              ...section,
              content: (section.content || []).filter(item => item.id !== contentToRemove.id)
            };
          }
          return section;
        })
      })));

      // Mettre à jour la section sélectionnée si elle est affichée
      if (selectedSectionForContent && selectedSectionForContent.id === sectionId) {
        setSelectedSectionForContent(prev => ({
          ...prev,
          content: (prev.content || []).filter(item => item.id !== contentToRemove.id)
        }));
      }

      toast.success("Contenu supprimé avec succès !");

    } catch (error) {
      const errorMessage = error.response?.data?.detail || "Une erreur est survenue lors de la suppression.";
      toast.error(errorMessage);
      console.error("Erreur lors de la suppression du contenu:", error);
    }
  };

  // Start editing a content: open ContentManager in edit mode
  const handleStartEditContent = (section, content) => {
    // Ensure selected section is the one containing content
    setSelectedStepForContent(prev => prev || createdSteps.find(s => s.sections.some(sec => sec.id === section.id)));
    setSelectedSectionForContent(section);
    setEditingContent(content);
  };

  // Receive updated content from ContentManager and update createdSteps state
  const handleContentUpdate = (sectionId, updatedContent) => {
    setCreatedSteps(prev => prev.map(step => ({
      ...step,
      sections: step.sections.map(section => {
        if (section.id !== sectionId) return section;
        return {
          ...section,
          content: (section.content || []).map(c => c.id === updatedContent.id ? { ...c, ...updatedContent } : c)
        };
      })
    })));

    // If currently selected section is the one, update it too
    if (selectedSectionForContent && selectedSectionForContent.id === sectionId) {
      setSelectedSectionForContent(prev => ({ ...prev, content: (prev.content || []).map(c => c.id === updatedContent.id ? { ...c, ...updatedContent } : c) }));
    }

    // Close editing modal
    setEditingContent(null);
    toast.success('Contenu mis à jour avec succès !');
  };



  const renderContent = (content) => {
    // Normaliser champs et fallback depuis cache contentDetails
    const cached = content && content.id ? contentDetails[content.id] : null;
    const type = content?.type || content?.content_type || content?.contentType || cached?.content_type || cached?.type;
    const name = content?.name || content?.title || content?.nom || content?.label || cached?.name || cached?.title || cached?.label;
    const description = content?.description || content?.text || cached?.description || cached?.text;
    const image = content?.image || content?.imagePreview || cached?.image || cached?.image_url || (cached?.product && cached.product.image) || '/assets/images/placeholder.png';

    // If we don't have a type or name for this content and there is an id, try to fetch details
    if ((!type || !name) && content?.id && !cached) {
      // trigger async fetch (fire-and-forget, cached) — avoid blocking render
      fetchContentDetails(content.id).catch(err => console.warn('Erreur fetch content details', err));
      // Display a placeholder until data arrives
      return (
        <div className="col-12 mb-3">
          <div className="text-center text-muted p-3">Chargement du contenu...</div>
        </div>
      );
    }

    switch ((type || '').toUpperCase()) {
      case 'PRODUCTS':
        return (
          <label>
            <div className="materiau-wrapper" style={{ borderRadius:'0px', width: '100%', overflow: 'hidden', position: 'relative', zIndex: 0, height: '150px' }}>
              <img src={image} alt={name || 'Produit'} style={{ maxWidth: '100%' }} />
              <div className="rectangle px-4 py-1">
                <p className="Card-title">{name}</p>
                {description && <p className="Card-sub-title">{description}</p>}
              </div>
            </div>
          </label>
        );

      case 'TEXT':
        return (
          <div className="col-12 mb-3">
            <div className="text-content p-3 border rounded">
              {name && <h6>{name}</h6>}
              <p>{description}</p>
            </div>
          </div>
        );

      case 'INPUT':
        return (
          <div className="col-12 mb-3">
            <div className="d-flex flex-column">
              <label className="label-be">{name}</label>
              <div className="input-wrapper">
                <input type="text" placeholder={content?.placeholder || cached?.placeholder || ''} disabled />
                {content?.suffix || cached?.suffix ? <span className="unit">{content?.suffix || cached?.suffix}</span> : null}
              </div>
              {content?.order && <small className="text-muted">Ordre: {content.order}</small>}
            </div>
          </div>
        );

      case 'OTHER_CHOICES':
        return (
          <div className="col-12 mb-3">
            <div className="other-choice-box p-3 border rounded">
              <p className="text-center fw-bold">{name || 'Autre choix'}</p>
              {content?.order && <small className="text-muted d-block text-center">Ordre: {content.order}</small>}
            </div>
          </div>
        );

      case 'CHOICES':
        return (
          <div className="col-12 mb-3">
            <label className="label-utility">
              <input type="radio" name={`choice_${content?.id || Math.random()}`} defaultValue="autre" className="utility-radio" />
              <div className="utility mb-3"><span>{name || 'Choix'}</span></div>
            </label>
          </div>
        );

      default:
        // Unknown type — try to render a generic card
        return (
          <div className="col-12 mb-3">
            <div className="text-content p-3 border rounded">
              <h6>{name || `Contenu #${content?.id || ''}`}</h6>
              <p>{description || JSON.stringify(content)}</p>
            </div>
          </div>
        );
    }
  };

  // Fetch content details and cache them to improve rendering when loaded from backend
  const fetchContentDetails = async (contentId) => {
    if (!contentId) return null;
    if (contentDetails[contentId]) return contentDetails[contentId];
    try {
      const resp = await API.get(`/be/admin/contents/${contentId}/`);
      const data = resp.data;
      setContentDetails(prev => ({ ...prev, [contentId]: data }));
      return data;
    } catch (err) {
      console.warn(`Erreur lors de la récupération du content ${contentId}:`, err);
      return null;
    }
  };

  const handleFinishProject = () => {
    // Sauvegarder toutes les données du projet en local storage
    const projectData = {
      nom: projectName,
      description: projectDescription,
      image: projectImage,
      steps: createdSteps,
      createdAt: new Date().toISOString()
    };

    localStorage.setItem('BeProjectData', JSON.stringify(projectData));
    console.log('Données du projet sauvegardées:', projectData);
    toast.success('Projet préparé avec succès !');
    
    // Naviguer vers la page suivante
    navigate('/bureau-etude');
  };

  const handleBackToProject = () => {
    setCurrentStep(1);
  };

  const handleBackToSteps = () => {
    setCurrentStep(2);
  };

  const handleNextToContent = () => {
    if (createdSteps.length === 0) {
      toast.error('Veuillez créer au moins une étape avec des sections');
      return;
    }
    
    // Vérifier qu'il y a au moins une section dans toutes les étapes
    const hasSections = createdSteps.some(step => step.sections.length > 0);
    if (!hasSections) {
      toast.error('Veuillez créer au moins une section dans une étape');
      return;
    }

    setCurrentStep(4);
    toast.success('Étape 3 terminée ! Vous pouvez maintenant ajouter du contenu aux sections.');
  };

  const handleBackToSections = () => {
    setCurrentStep(3);
  };

  const handleSelectSectionForContent = (step, section) => {
    setSelectedStepForContent(step);
    // Normaliser la section sélectionnée pour s'assurer que `content` est un tableau
    const normalizedSection = { ...section, content: section.content || section.contents || [] };
    setSelectedSectionForContent(normalizedSection);
    setCurrentStep(4);
    toast.success(`Section sélectionnée : ${section.title} de l'étape ${step.title}`);
  };



  return (
    <div>
        <BeHead />
        <div className="content-body">
            <div className="container-fluid">
                <div className="container-fluid overflow-hidden">
                    <div className="row">
                    <div className="col-12 bg-white p-5 ml-4">
                        <div className="mb-5">
                        {/* <p className="fw-bold fs-3"><LiaTimesSolid /></p> */}
                        <div className="title pt-2">
                            <h1 className="">{isEditMode ? `Modifier le Projet : ${projectName}` : "Créer un Nouveau Projet"}</h1>
                            <p className="fst-italic">
                              {currentStep === 1 && "Renseignez les informations de votre projet"}
                              {currentStep === 2 && "Créez des étapes pour votre projet"}
                              {currentStep === 3 && "Sélectionnez une étape et créez ses sections avec contenu dynamique"}
                            </p>
                        </div>
                        </div>
                        
                        {/* Indicateur de progression */}
                        <div className="mb-4">
                          <div className="d-flex align-items-center flex-wrap">
                            <div onClick={()=> setCurrentStep(1)} className={`rounded-circle d-flex align-items-center justify-content-center me-3 ${currentStep >= 1 ? 'bg-primary text-white' : 'bg-secondary text-white'}`} 
                                 style={{width: '40px', height: '40px'}}>
                              1
                            </div>
                            <div className={`me-3 ${currentStep >= 1 ? 'text-primary' : 'text-muted'}`}>
                              Projet
                            </div>
                            <div className="me-3">
                              <i className="fas fa-arrow-right text-muted"></i>
                            </div>
                            <div onClick={()=> setCurrentStep(2)} className={`rounded-circle d-flex align-items-center justify-content-center me-3 ${currentStep >= 2 ? 'bg-primary text-white' : 'bg-secondary text-white'}`} 
                                 style={{width: '40px', height: '40px'}}>
                              2
                            </div>
                            <div className={`me-3 ${currentStep >= 2 ? 'text-primary' : 'text-muted'}`}>
                              Étapes
                            </div>
                            <div className="me-3">
                              <i className="fas fa-arrow-right text-muted"></i>
                            </div>
                            <div onClick={()=> setCurrentStep(3)} className={`rounded-circle d-flex align-items-center justify-content-center me-3 ${currentStep >= 3 ? 'bg-primary text-white' : 'bg-secondary text-white'}`} 
                                 style={{width: '40px', height: '40px'}}>
                              3
                            </div>
                            <div className={`me-3 ${currentStep >= 3 ? 'text-primary' : 'text-muted'}`}>
                              Sections
                            </div>
                            <div className="me-3">
                              <i className="fas fa-arrow-right text-muted"></i>
                            </div>
                            <div onClick={()=> setCurrentStep(4)} className={`rounded-circle d-flex align-items-center justify-content-center me-3 ${currentStep >= 4 ? 'bg-primary text-white' : 'bg-secondary text-white'}`} 
                                 style={{width: '40px', height: '40px'}}>
                              4
                            </div>
                            <div className={`me-3 ${currentStep >= 4 ? 'text-primary' : 'text-muted'}`}>
                              Contenu
                            </div>
                          </div>
                        </div>

                        {currentStep === 1 && (
                          <>
                            {/* 1. Formulaire du projet */}
                            <div className="mb-4">
                              <h4 className="mb-3">1. Informations du Projet</h4>
                              <div className="row mb-4">
                                <div className="col-md-6">
                                  <div className="form-group mb-3">
                                    <label className="form-label fw-bold">Nom du Projet *</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={projectName}
                                      onChange={(e) => setProjectName(e.target.value)}
                                      placeholder="Entrez le nom de votre projet"
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group mb-3">
                                    <label className="form-label fw-bold">Description du Projet *</label>
                                    <input
                                      type='text'
                                      className="form-control"
                                      value={projectDescription}
                                      onChange={(e) => setProjectDescription(e.target.value)}
                                      placeholder="Décrivez votre projet"
                                      rows="3"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Upload d'image */}
                              <div className="row mb-4">
                                <div className="col-md-6">
                                  <div className="form-group mb-3">
                                    <label className="form-label fw-bold">Image du Projet</label>
                                    <input
                                      type="file"
                                      className="form-control"
                                      accept="image/*"
                                      onChange={handleImageChange}
                                    />
                                    <small className="text-muted">Formats acceptés: JPG, PNG, GIF (max 5MB)</small>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  {imagePreview && ( 
                                    <div className="text-center">
                                      <img 
                                        src={imagePreview} 
                                        alt="Aperçu" 
                                        className="img-fluid rounded"
                                        style={{ maxHeight: '150px', maxWidth: '200px' }}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className='d-flex justify-content-between progress-btn mt-4'>
                                <span />
                                <div>
                                <button type="button" className="btn button me-3">
                                    <Link className='text-white fw-bold' to="/stats">Retour</Link>
                                </button>
                                <button 
                                  onClick={handleSaveOrUpdateProject} 
                                  type="button" 
                                  className={`btn fw-bold ${projectName && projectDescription ? 'button-btn text-white' : 'btn-secondary'}`}
                                  disabled={!projectName.trim() || !projectDescription.trim()}
                                >
                                    {isEditMode ? "Enregistrer et continuer" : "Créer et continuer"}
                                </button>
                                </div>
                            </div>
                          </>
                        )}

                        {currentStep === 2 && (
                          <>
                            {/* 2. Création d'étape */}
                            <div className="mb-4">
                              <h4 className="mb-3">2. Créer une Étape</h4>
                              <div className="row">
                                {/* <div className="col-md-4">
                                  <div className="form-group mb-3">
                                    <label className="form-label fw-bold">Ordre *</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={stepOrder}
                                      onChange={(e) => setStepOrder(e.target.value)}
                                      placeholder="Ordre de l'étape"
                                      min="1"
                                      required
                                    />
                                  </div>
                                </div> */}
                                <div className="col-md-4">
                                  <div className="form-group mb-3">
                                    <label className="form-label fw-bold">Titre *</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={stepTitle}
                                      onChange={(e) => setStepTitle(e.target.value)}
                                      placeholder="Titre de l'étape"
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group mb-3">
                                    <label className="form-label fw-bold">Description *</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={stepDescription}
                                      onChange={(e) => setStepDescription(e.target.value)}
                                      placeholder="Sous-titre de l'étape"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-12">
                                                                     <button 
                                     onClick={handleSaveStep} // Cette fonction gère maintenant la création et la mise à jour
                                     type="button" 
                                     className={`btn fw-bold ${stepOrder && stepTitle && stepDescription ? (editingStep ? 'btn-primary' : 'btn-success') : 'btn-secondary'}`}
                                     disabled={!stepTitle || !stepDescription}
                                   >
                                     <i className={`fas ${editingStep ? 'fa-save' : 'fa-plus'} me-2`}></i>
                                     {editingStep ? "Mettre à jour l'Étape" : "Créer l'Étape"}
                                   </button>
                                   {editingStep && (
                                       <button className="btn btn-secondary fw-bold ms-2" onClick={handleCancelEditStep}>
                                           Annuler la modification
                                       </button>
                                   )}
                                </div>
                              </div>

                                                             {/* Liste des étapes créées */}
                               {createdSteps.length > 0 && (
                                 <div className="mt-4">
                                   <h5>Étapes créées :</h5>
                                   <p className="text-muted mb-3">
                                     <i className="fas fa-info-circle me-2"></i>
                                     Cliquez sur une étape pour ajouter des sections
                                   </p>
                                   <div className="row">
                                     {oldCreatedSteps.length > 0 && oldCreatedSteps.map((step) => (
                                      <div key={step.id} className="col-md-6 mb-3">
                                         <div 
                                           className="card cursor-pointer border-primary border-2"
                                           onClick={() => {
                                             setCurrentStep(3);
                                             setSelectedStepForSection(step);
                                             toast.success(`Étape sélectionnée : ${step.title}`);
                                           }}
                                           style={{ 
                                             cursor: 'pointer',
                                             transition: 'all 0.3s ease',
                                             border: '2px solid #007bff',
                                             backgroundColor: '#f8f9fa'
                                           }}
                                           onMouseEnter={(e) => {
                                             e.target.style.transform = 'translateY(-3px)';
                                             e.target.style.boxShadow = '0 6px 12px rgba(0,123,255,0.2)';
                                             e.target.style.borderColor = '#0056b3';
                                           }}
                                           onMouseLeave={(e) => {
                                             e.target.style.transform = 'translateY(0)';
                                             e.target.style.boxShadow = 'none';
                                             e.target.style.borderColor = '#007bff';
                                           }}
                                         >
                                           <div className="card-body text-center" onClick={() => {
                                               setCurrentStep(3);
                                               setSelectedStepForSection(step);
                                              //  toast.info(`Étape sélectionnée : ${step.title}`);
                                             }}>
                                             <div className="mb-2">
                                               <i className="fas fa-layer-group text-primary" style={{fontSize: '2rem'}}></i>
                                             </div>
                                             <h6 className="card-title fw-bold" style={{color: "#007bff"}}>{step.title}</h6>
                                             <p className="card-text text-muted">{step.description}</p>
                                             <div className="d-flex justify-content-between align-items-center mb-2">
                                               <small className="text-muted">Ordre: {step.order}</small>
                                               <small className="text-muted">
                                                 {step.sections.length} section{step.sections.length !== 1 ? 's' : ''}
                                               </small>
                                             </div>
                                             <div className="mt-3">
                                               <span className="badge bg-primary">
                                                 <i className="fas fa-plus me-1"></i>
                                                 Ajouter des sections
                                               </span>
                                             </div>
                                           </div>
                                           <div className="card-footer d-flex justify-content-end gap-2">
                                                <button className="btn btn-sm btn-outline-primary" onClick={(e) => { e.stopPropagation(); handleEditStep(step); }}>
                                                    <i className="fas fa-pencil-alt me-1"></i> Modifier
                                                </button>
                                                <button className="btn btn-sm btn-outline-danger" onClick={(e) => { e.stopPropagation(); handleDeleteStep(step.id); }}>
                                                    <i className="fas fa-trash me-1"></i> Supprimer
                                                </button>
                                           </div>
                                         </div>
                                       </div>
                                     ))}
                                     {createdSteps.map((step) => (
                                       <div key={step.id} className="col-md-6 mb-3">
                                         <div 
                                           className="card cursor-pointer border-primary border-2"
                                           onClick={() => {
                                             setCurrentStep(3);
                                             setSelectedStepForSection(step);
                                             toast.success(`Étape sélectionnée : ${step.title}`);
                                           }}
                                           style={{ 
                                             cursor: 'pointer',
                                             transition: 'all 0.3s ease',
                                             border: '2px solid #007bff',
                                             backgroundColor: '#f8f9fa'
                                           }}
                                           onMouseEnter={(e) => {
                                             e.target.style.transform = 'translateY(-3px)';
                                             e.target.style.boxShadow = '0 6px 12px rgba(0,123,255,0.2)';
                                             e.target.style.borderColor = '#0056b3';
                                           }}
                                           onMouseLeave={(e) => {
                                             e.target.style.transform = 'translateY(0)';
                                             e.target.style.boxShadow = 'none';
                                             e.target.style.borderColor = '#007bff';
                                           }}
                                         >
                                           <div className="card-body text-center" onClick={() => {
                                               setCurrentStep(3);
                                               setSelectedStepForSection(step);
                                              //  toast.info(`Étape sélectionnée : ${step.title}`);
                                             }}>
                                             <div className="mb-2">
                                               <i className="fas fa-layer-group text-primary" style={{fontSize: '2rem'}}></i>
                                             </div>
                                             <h6 className="card-title fw-bold" style={{color: "#007bff"}}>{step.title}</h6>
                                             <p className="card-text text-muted">{step.description}</p>
                                             <div className="d-flex justify-content-between align-items-center mb-2">
                                               <small className="text-muted">Ordre: {step.order}</small>
                                               <small className="text-muted">
                                                 {step.sections.length} section{step.sections.length !== 1 ? 's' : ''}
                                               </small>
                                             </div>
                                             <div className="mt-3">
                                               <span className="badge bg-primary">
                                                 <i className="fas fa-plus me-1"></i>
                                                 Ajouter des sections
                                               </span>
                                             </div>
                                           </div>
                                           <div className="card-footer d-flex justify-content-end gap-2">
                                                <button className="btn btn-sm btn-outline-primary" onClick={(e) => { e.stopPropagation(); handleEditStep(step); }}>
                                                    <i className="fas fa-pencil-alt me-1"></i> Modifier
                                                </button>
                                                <button className="btn btn-sm btn-outline-danger" onClick={(e) => { e.stopPropagation(); handleDeleteStep(step.id); }}>
                                                    <i className="fas fa-trash me-1"></i> Supprimer
                                                </button>
                                           </div>
                                         </div>
                                       </div>
                                     ))}
                                   </div>
                                 </div>
                               )}
                            </div>

                            <div className='d-flex justify-content-between progress-btn mt-4'>
                                <div>
                                <button 
                                  onClick={handleBackToProject} 
                                  type="button" 
                                  className="btn button me-3"
                                >
                                    Retour
                                </button>
                                </div>
                                <div>
                                <button 
                                  onClick={handleNextToSections} 
                                  type="button" 
                                  className={`btn fw-bold ${createdSteps.length > 0 ? 'button-btn text-white' : 'btn-secondary'}`}
                                  disabled={createdSteps.length === 0}
                                >
                                    Suivant
                                </button>
                                </div>
                            </div>
                          </>
                        )}

                        {currentStep === 3 && (
                          <>
                            {/* 3. Sélection d'étape et création de section avec contenu dynamique */}
                            <div className="mb-4">
                              <h4 className="mb-3">3. Créer des Sections avec Contenu Dynamique</h4>
                              
                              {/* Sélection d'étape */}
                              <div className="mb-4">
                                <h5>Sélectionnez une étape pour ajouter des sections :</h5>
                                <div className="row">
                                  {createdSteps.map((step) => (
                                    <div key={step.id} className="col-md-6 mb-2">
                                      <div 
                                        className={`card cursor-pointer ${selectedStepForSection?.id === step.id ? 'border-primary shadow' : 'border-light'}`}
                                        onClick={() => handleSelectStepForSection(step)}
                                        style={{ 
                                          cursor: 'pointer',
                                          transition: 'all 0.3s ease',
                                          border: selectedStepForSection?.id === step.id ? '2px solid #007bff' : '1px solid #dee2e6'
                                        }}
                                        onMouseEnter={(e) => {
                                          if (selectedStepForSection?.id !== step.id) {
                                            e.target.style.transform = 'translateY(-2px)';
                                            e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                                          }
                                        }}
                                        onMouseLeave={(e) => {
                                          if (selectedStepForSection?.id !== step.id) {
                                            e.target.style.transform = 'translateY(0)';
                                            e.target.style.boxShadow = 'none';
                                          }
                                        }}
                                      >
                                        <div className="card-body">
                                          <h6 className="card-title" style={{color: "#007bff"}}>{step.title}</h6>
                                          <p className="card-text">{step.description}</p>
                                          <small className="text-muted">Ordre: {step.order}</small>
                                          <div className="mt-2 d-flex justify-content-between align-items-center">
                                            {selectedStepForSection?.id === step.id ? (
                                              <span className="badge bg-primary">✓ Sélectionné</span>
                                            ) : (
                                              <small className="text-primary">
                                                <i className="fas fa-plus me-1"></i>
                                                Cliquez pour sélectionner
                                              </small>
                                            )}
                                            <small className="text-muted">
                                              {step.sections.length} section{step.sections.length !== 1 ? 's' : ''}
                                            </small>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>

                              {/* Création de section pour l'étape sélectionnée */}
                              {selectedStepForSection && (
                                <div className="mb-4">
                                  <div className="d-flex align-items-center mb-3">
                                    <h5 className="mb-0 me-3">Créer une section pour l'étape : {selectedStepForSection.title}</h5>
                                    {selectedStepForSection.sections.length > 0 && (
                                      <span className="badge bg-info">
                                        {selectedStepForSection.sections.length} section{selectedStepForSection.sections.length !== 1 ? 's' : ''} existante{selectedStepForSection.sections.length !== 1 ? 's' : ''}
                                      </span>
                                    )}
                                  </div>
                                  <div className="row">
                                    {/* <div className="col-md-6">
                                      <div className="form-group mb-3">
                                        <label className="form-label fw-bold">Ordre *</label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={sectionOrder}
                                          onChange={(e) => setSectionOrder(e.target.value)}
                                          placeholder="Ordre de la section"
                                          min="1"
                                          required
                                        />
                                      </div>
                                    </div> */}
                                    <div className="col-md-6">
                                      <div className="form-group mb-3">
                                        <label className="form-label fw-bold">Titre *</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={sectionTitle}
                                          onChange={(e) => setSectionTitle(e.target.value)}
                                          placeholder="Titre de la section"
                                          required
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-12">
                                      <button 
                                        onClick={handleCreateSection} 
                                        type="button" 
                                        className={`btn fw-bold ${sectionOrder && sectionTitle ? 'btn-success' : 'btn-secondary'}`}
                                        disabled={!sectionTitle}
                                      >
                                        Créer la Section
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}

                                                             {/* Affichage des sections créées */}
                               {selectedStepForSection && selectedStepForSection.sections.length > 0 && (
                                 <div className="mt-4">
                                   <div className="d-flex align-items-center mb-3">
                                     <h5 className="mb-0 me-3">Sections créées pour {selectedStepForSection.title} :</h5>
                                     <span className="badge bg-success">
                                       {selectedStepForSection.sections.length} section{selectedStepForSection.sections.length !== 1 ? 's' : ''}
                                     </span>
                                   </div>
                                                                       <div className="row">
                                      {selectedStepForSection.sections.map((section, index) => (
                                        <div key={section.id} className="col-md-6 mb-3">
                                          <div 
                                            className="card border-success cursor-pointer"
                                            onClick={() => handleSelectSectionForContent(selectedStepForSection, section)}
                                            style={{ 
                                              cursor: 'pointer',
                                              transition: 'all 0.3s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                              e.target.style.transform = 'translateY(-3px)';
                                              e.target.style.boxShadow = '0 6px 12px rgba(40,167,69,0.2)';
                                              e.target.style.borderColor = '#28a745';
                                            }}
                                            onMouseLeave={(e) => {
                                              e.target.style.transform = 'translateY(0)';
                                              e.target.style.boxShadow = 'none';
                                              e.target.style.borderColor = '#28a745';
                                            }}
                                          >
                                            <div className="card-header bg-success text-white">
                                              <h6 className="mb-0">
                                                <i className="fas fa-list me-2"></i>
                                                {section.title}
                                              </h6>
                                            </div>
                                            <div className="card-body text-center">
                                              <p className="text-muted mb-0">
                                                Section créée avec succès
                                              </p>
                                              <small className="text-muted">
                                                Cliquez pour ajouter du contenu
                                              </small>
                                              <div className="mt-2">
                                                <span className="badge bg-light text-success">
                                                  <i className="fas fa-plus me-1"></i>
                                                  Ajouter du contenu
                                                </span>
                                              </div>
                                              <div className="card-footer d-flex justify-content-end gap-2">
                                                <button className="btn btn-sm btn-outline-primary" onClick={(e) => { e.stopPropagation(); handleEditSection(section); }}>
                                                    <i className="fas fa-pencil-alt me-1"></i> Modifier
                                                </button>
                                                <button className="btn btn-sm btn-outline-danger" onClick={(e) => { e.stopPropagation(); handleDeleteSection(section.id); }}>
                                                    <i className="fas fa-trash me-1"></i> Supprimer
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                 </div>
                               )}
                            </div>

                            <div className='d-flex justify-content-between progress-btn mt-4'>
                                <div>
                                <button 
                                  onClick={handleBackToSteps} 
                                  type="button" 
                                  className="btn button me-3"
                                >
                                    Retour aux étapes
                                </button>
                                </div>
                                <div>
                                <button 
                                  onClick={handleNextToContent} 
                                  type="button" 
                                  className={`btn fw-bold ${createdSteps.some(step => step.sections.length > 0) ? 'button-btn text-white' : 'btn-secondary'}`}
                                  disabled={!createdSteps.some(step => step.sections.length > 0)}
                                >
                                    Suivant - Ajouter du contenu
                                </button>
                                </div>
                            </div>
                          </>
                                                 )}

                                                   {currentStep === 4 && (
                            <>
                              {/* 4. Ajout de contenu aux sections */}
                              <div className="mb-4">
                                <h4 className="mb-3">4. Ajouter du Contenu aux Sections</h4>
                                
                                {/* Affichage de la section sélectionnée */}
                                {selectedStepForContent && selectedSectionForContent ? (
                                  <div className="mb-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <h5 className="mb-0 me-3">
                                        Ajouter du contenu à la section : {selectedSectionForContent.title}
                                      </h5>
                                      <span className="badge bg-primary">
                                        Étape : {selectedStepForContent.title}
                                      </span>
                                    </div>
                                    
                                    <div className="card border-primary">
                                      <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                                        <h6 className="mb-0">
                                          <i className="fas fa-list me-2"></i>
                                          {selectedSectionForContent.title}
                                        </h6>
                                        <ContentManager 
                                          section={selectedSectionForContent}
                                          onContentAdd={handleContentAdd}
                                          onContentRemove={handleContentRemove}
                                        />
                                      </div>
                                      <div className="card-body">
                                        <div className="row">
                                          {/* {selectedSectionForContent.content.map((content) => ( */}
                                          {Array.isArray(selectedSectionForContent?.content) && selectedSectionForContent.content.map((content) => (
                                            <div key={content.id} className="col-6 col-md-3 mb-4 position-relative">
                                              <div className="row">
                                                {renderContent(content)}
                                              </div>
                                              <button
                                                type="button"
                                                className="btn btn-danger btn-sm position-absolute"
                                                style={{ top: "5px", right: "5px" }}
                                                onClick={() => handleContentRemove(selectedSectionForContent.id, content)}
                                              >
                                                <FaTrash />
                                              </button>
                                              <button
                                                type="button"
                                                className="btn btn-secondary btn-sm position-absolute"
                                                style={{ top: "5px", left: "5px" }}
                                                onClick={() => handleStartEditContent(selectedSectionForContent, content)}
                                              >
                                                <i className="fas fa-edit"></i>
                                              </button>
                                            </div>
                                          ))}
                                        </div>
                                        {/* {selectedSectionForContent.content.length === 0 && ( */}
                                        {(!selectedSectionForContent?.content || selectedSectionForContent.content.length === 0) && (
                                          <div className="text-center py-3">
                                            <i className="fas fa-plus-circle text-muted" style={{fontSize: '2rem'}}></i>
                                            <p className="text-muted mt-2">
                                              Aucun contenu ajouté à cette section
                                            </p>
                                            <small className="text-muted">
                                              Utilisez le bouton "Ajouter du contenu" ci-dessus
                                            </small>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="alert alert-info">
                                    <i className="fas fa-info-circle me-2"></i>
                                    Aucune section sélectionnée. Retournez à l'étape 3 et cliquez sur une section pour ajouter du contenu.
                                  </div>
                                )}

                                {/* ContentManager en mode édition (modal pré-remplie) */}
                                {editingContent && (
                                  <ContentManager
                                    section={selectedSectionForContent}
                                    onContentAdd={handleContentAdd}
                                    onContentRemove={handleContentRemove}
                                    thisContent={editingContent}
                                    onContentUpdate={(updated) => handleContentUpdate(selectedSectionForContent.id, updated)}
                                  />
                                )}

                                {/* Sélection d'autres sections */}
                                <div className="mt-4">
                                  <h5>Ou sélectionnez une autre section :</h5>
                                  <div className="row">
                                    {createdSteps.map((step) => (
                                      <div key={step.id} className="col-md-6 mb-2">
                                        <div className="card">
                                          <div className="card-header">
                                            <h6 className="mb-0">{step.title}</h6>
                                          </div>
                                          <div className="card-body">
                                            {step.sections.length > 0 ? (
                                              <div className="row">
                                                {step.sections.map((section) => (
                                                  <div key={section.id} className="col-md-6 mb-2">
                                                    <div 
                                                      className="card border-light cursor-pointer"
                                                      onClick={() => handleSelectSectionForContent(step, section)}
                                                      style={{ 
                                                        cursor: 'pointer',
                                                        transition: 'all 0.3s ease'
                                                      }}
                                                      onMouseEnter={(e) => {
                                                        e.target.style.transform = 'translateY(-2px)';
                                                        e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                                                      }}
                                                      onMouseLeave={(e) => {
                                                        e.target.style.transform = 'translateY(0)';
                                                        e.target.style.boxShadow = 'none';
                                                      }}
                                                    >
                                                      <div className="card-body text-center">
                                                        <h6 className="card-title">{section.title}</h6>
                                                        <small className="text-muted">
                                                          {section.content?.length || 0} contenu{section.content?.length !== 1 ? 's' : ''}
                                                        </small>
                                                        <div className="mt-2">
                                                          <span className="badge bg-primary">
                                                            <i className="fas fa-plus me-1"></i>
                                                            Ajouter du contenu
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                ))}
                                              </div>
                                            ) : (
                                              <p className="text-muted text-center">
                                                Aucune section dans cette étape
                                              </p>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>

                              <div className='d-flex justify-content-between progress-btn mt-4'>
                                  <div>
                                  <button 
                                    onClick={handleBackToSections} 
                                    type="button" 
                                    className="btn button me-3"
                                  >
                                      Retour aux sections
                                  </button>
                                  </div>
                                  <div>
                                  <button 
                                    onClick={handleFinishProject} 
                                    type="button" 
                                    className="btn button-btn text-white fw-bold"
                                  >
                                      Terminer le Projet
                                  </button>
                                  </div>
                              </div>
                            </>
                          )}
                         
                         
                         </div>
                     </div>
                     </div>
                 </div>
             </div>
         </div>
     
   );
 };

export default BeSelectProjet;